import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';

export type AppSource = 'ios_app' | 'android_app';

export const getAppSource = (): AppSource | null => {
  if (!Capacitor.isNativePlatform()) return null;
  const platform = Capacitor.getPlatform();
  if (platform === 'ios') return 'ios_app';
  if (platform === 'android') return 'android_app';
  return null;
};

const withSourceParam = (url: string, source: AppSource): string => {
  try {
    const parsed = new URL(url);
    parsed.searchParams.set('source', source);
    return parsed.toString();
  } catch {
    return url;
  }
};

export const openExternal = async (url: string): Promise<void> => {
  const source = getAppSource();
  if (source) {
    await Browser.open({ url: withSourceParam(url, source), presentationStyle: 'popover' });
    return;
  }
  window.open(url, '_blank', 'noopener,noreferrer');
};
